import React, { useState, useCallback, FC, useEffect } from 'react';
// libs
import clsx from 'clsx';
import { Route, useHistory } from 'react-router-dom';
// material core
import CssBaseline from '@material-ui/core/CssBaseline';

// containers
import ErrorBoundary from 'containers/ErrorBoundary';

// components
import NavBar from './NavBar';
import NavBar2 from './NavBar/NavBarUpgraded';
import TopBar from './TopBar';

// styles
import useStyles from './styles';
import { Props } from 'models/IRoutes';


const MainLayout: FC<Props> = (props) => {
  const { children,header,subheader=[] } = props
  const classes = useStyles();
  const [isDrawer, setIsDrawer] = useState(true);

  const _handleToogleDrawer = useCallback(() => {
    setIsDrawer(!isDrawer);
  }, [isDrawer]);


  
  useEffect(() => {
    console.log("props changed", props);
  },[props])

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* <NavBar isDrawer={isDrawer} /> */}
      <NavBar2 isDrawer={isDrawer} />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: isDrawer,
        })}
      >
        {children}
      </main>
    </div>
  );
};


export default MainLayout;
